import Fuse from 'fuse.js';

export default angular.module('eventix.common.services.fuse', [])
    .factory('Fuse', function($window) {
        return Fuse;
    }).name;
